// The modules supported by module switcher.
export enum Module {
    Mail = "Mail",
    Calendar = "Calendar",
    People = "People",
    PeopleNew = "PeopleNew",
    FilesHub = "FilesHub",
    Tasks = "Tasks",
    Eventify = "Eventify",
    PublishedCalendar = "PublishedCalendar",
    MailDeepLink = "MailDeepLink",
    AppHost = "AppHost",
    CalendarDeepLink = "CalendarDeepLink",
    Groups = "Groups",
    MicrosoftPlaces = "MicrosoftPlaces",
    Addison = "Addison",
    DelegateAccess = "DelegateAccess"
}

export function GetModuleFromString(moduleName: string): Module | undefined {
    switch (moduleName.toLowerCase()) {
        case Module.Mail.toLowerCase():
            return Module.Mail;
        case Module.Calendar.toLowerCase():
            return Module.Calendar;
        case Module.People.toLowerCase():
            return Module.People;
        case Module.PeopleNew.toLowerCase():
            return Module.PeopleNew;
        case Module.FilesHub.toLowerCase():
            return Module.FilesHub;
        case Module.Tasks.toLowerCase():
            return Module.Tasks;
        case Module.PublishedCalendar.toLowerCase():
            return Module.PublishedCalendar;
        case Module.MailDeepLink.toLowerCase():
            return Module.MailDeepLink;
        case Module.AppHost.toLowerCase():
            return Module.AppHost;
        case Module.CalendarDeepLink.toLowerCase():
            return Module.CalendarDeepLink;
        case Module.Groups.toLowerCase():
            return Module.Groups;
        case Module.MicrosoftPlaces.toLowerCase():
            return Module.MicrosoftPlaces;
        case Module.Addison.toLowerCase():
            return Module.Addison;
        case Module.DelegateAccess.toLowerCase():
            return Module.DelegateAccess;
        default:
            return undefined;
    }
}

// This is all the modules that are enabled to use the shared bootstrap code of
// appBootstrap
export type ModulesEnabledForAppBootstrap = Extract<Module, Module.Mail | Module.Calendar | Module.People | Module.FilesHub | Module.MailDeepLink | Module.AppHost | Module.CalendarDeepLink | Module.Groups | Module.MicrosoftPlaces | Module.DelegateAccess>;

// This list all the modules that are enabled for switching within the same load of the page
// without a url redirect
export type ModulesEnabledForSwitch = Extract<Module, Module.Mail | Module.Calendar | Module.People | Module.FilesHub | Module.AppHost | Module.Groups | Module.Tasks>;
